import { Injectable } from '@angular/core';
import { EventTypes, ITypedResponse } from '@caslink/common-client';
import { CardStatus } from '@caslink/common-client/ng-app/alerts/typings/CardStatus';
import { CardStatusUpdateInfo } from '@caslink/common-client/ng-app/alerts/typings/CardStatusUpdateInfo';
import { ProxyService } from '@caslink/common-client/ng-app/proxy/ProxyService';
import * as _ from 'lodash';
import { ISensorDetailModel, ISetpointModel } from '../shared/models/models';
import { CommonBroadcastService } from '@caslink/common-client/ng-app/common-broadcast/common-broadcast.service';

@Injectable({
    providedIn: 'root'
})
export class ControlService {
    public static $name = 'controlService';

    constructor(
        private proxyService: ProxyService,
        private commonBroadcastService: CommonBroadcastService
    ) {
    }

    broadcastCardStatusUpdate(update: CardStatusUpdateInfo) {
        this.commonBroadcastService.broadcast(EventTypes.CardStatusUpdate, update);
    }

    /**
     * Given a context, a list of hardwareItemIds, and a status,
     * call broadcastCardStatusUpdate repeatedly with each hardwareItemId in place of the one attached to the context
     */
    broadcastMultipleCardStatusUpdate(locationId: number, hardwareItemIds: string[], status: CardStatus): void {
        let hardwareItemLen = hardwareItemIds.length;

        for (let i = 0; i < hardwareItemLen; i++) {
            let hardwareItemId = parseInt(hardwareItemIds[i], 10);

            this.broadcastCardStatusUpdate({
                locationId: locationId,
                hardwareItemId: hardwareItemId,
                status: status
            });
        }
    }

    getControlsForArea(
        locationId: number,
        locationAreaId: number
    ): angular.IPromise<CASLink.Device.Ui.ViewModel.DynamicControls.AggregateControlViewModel> {
        return this.proxyService.request({
            endPoint: 'hardware',
            notificationDelay: -1,
            route: 'getControlsForArea',
            routeParams: {
                locationId: locationId,
                locationAreaId: locationAreaId
            }
        }).as<CASLink.Device.Ui.ViewModel.DynamicControls.AggregateControlViewModel>();
    }

    getSensor(sensors: ISensorDetailModel[], name: string): ISensorDetailModel {
        return _.filter(sensors, (s: ISensorDetailModel) => s.sensorName === name)[0];
    }

    upsertSetpoint(hardwareItemId: number, setpoint: ISetpointModel) {
        return this.proxyService.request({
            endPoint: 'hardware',
            route: 'upsertSetpoint',
            routeParams: {
                hardwareItemId: hardwareItemId
            },
            data: setpoint
        }).as<ITypedResponse<ISetpointModel>>();
    }
}
